module.exports = __webpack_public_path__ + "static/media/IMG_4383.70586f7b.JPG";